<template>
  <button
    type="button"
    class="modal-close-button"
    :aria-label="ariaLabel"
    @click="$emit('click')"
  >
    <app-icon name="close" :size="22" />
  </button>
</template>

<script>
import AppIcon from "@/components/shared/AppIcon.vue";

export default {
  name: "ModalCloseButton",
  components: {AppIcon},
  props: {
    ariaLabel: {
      type: String,
      default: "Zavrieť okno",
    },
  },
};
</script>

<style scoped lang="scss">
.modal-close-button {
  display: inline-flex;
  flex: 0 0 40px;
  width: 40px;
  height: 40px;
  padding: 0;
  align-items: center;
  justify-content: center;
  border: 1px solid var(--app-border);
  border-radius: 12px;
  background: var(--app-surface-muted);
  color: var(--app-primary);
  cursor: pointer;
  transition: border-color .18s ease, background-color .18s ease, transform .18s ease;
}

.modal-close-button:hover {
  border-color: var(--app-primary);
  background: color-mix(in srgb, var(--app-primary) 10%, var(--app-surface-muted));
  transform: translateY(-1px);
}

.modal-close-button:focus-visible {
  border-color: var(--app-primary);
  outline: 2px solid color-mix(in srgb, var(--app-primary) 38%, transparent);
  outline-offset: 2px;
}
</style>
